export default defineNuxtRouteMiddleware(async (to, from) => {
  if (to.path === "/") {
    const supabase = useSupabaseClient();
    const user = useSupabaseUser();
    const { count: hasJobSeekers } = await supabase
      .from(JOB_SEEKER_TABLE)
      .select("*", { count: "exact", head: true })
      .eq("job_coach_id", user.value?.id ?? "");
    if (hasJobSeekers) {
      return navigateTo("/suggestions");
    }
  }
});
